<template>
    <div class="kt-portlet">
        <div class="kt-portlet__body">
            <div :id="chart_id" style="height: 200px;"></div>
        </div>
        <!-- <kt-button
                class="m-2 ml-auto"
                size="md"
                variant="success"
                type="button"
                id="export_btn"
                @click="exportToExcel"
        >
            {{ $t('btn.export_transaction_to_excel') }}
        </kt-button> -->
    </div>
</template>

<script>
import jQuery from 'jquery'
import $ from 'jquery'
import { ApiUrl } from '@/common/api.service'
import 'jquery-flot'
import { i18n } from '@/plugins/i18n'
import axios from 'axios';
import ApexCharts from "apexcharts";
import {totalOptions, transactionStatusVariant} from "../../../constants/ApexChartOptions"

export default {
    name: 'monthly_transaction_chart',

  props: {
    chart_data: {
      default() {
        return {}
      }
    },
    chart_id: {
      type: String,
      required: true,
    },
   chart_base: {
      type: String,
      required: false
    },
  },
  methods: {
    exportToExcel(){
      axios({
        url: ApiUrl.path('dashboard/transaction-excel'),
        method: 'GET',
        responseType: 'blob',
      }).then((response) => {
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement('a');

        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'transactions.xlsx');
        document.body.appendChild(fileLink);

        fileLink.click();
      });

    },
    fillOptions(){
      totalOptions.colors = this.fillColors()
      totalOptions.series = this.fillSeries()
      try {
        totalOptions.yaxis.title.text = ''
      } catch (e) {
        totalOptions.yaxis[0].title.text = ''
      }
      totalOptions.xaxis.categories = this.fillDateAxis()
    },
    fillSeries(){
      let data = []
      let chart_data = this.chart_data

      let succeeded = {
        name: 'موفق',
        data: this.chart_base == "price" ? Object.values(chart_data.succeeded) : Object.values(chart_data.succeeded_count),
      }

      let failed = {
        name: 'ناموفق',
        data: this.chart_base == "price" ? Object.values(chart_data.failed) : Object.values(chart_data.failed_count),
      }

      data.push(succeeded)
      data.push(failed)

      return data
    },
    fillColors(){
      let data = []
      let series = this.fillSeries()

      Object.values(series).forEach(function (status) {
        data.push(transactionStatusVariant.get(status.name))
      })
      return data
    },
    fillDateAxis() {
      let data = []
      let date_axis = this.chart_data.axis
      Object.keys(date_axis).forEach(function (item) {
        data.push(date_axis[item])
      })
      return data
    }
  },
  mounted(){
      this.fillOptions()
      let chart = new ApexCharts(document.querySelector("#" + this.chart_id) , totalOptions)
      chart.render()
  },
}
</script>

<style scoped>
    #tooltip {
        z-index: 100!important;
    }
    #kt_body > :first-child{
        z-index: initial !important;
    }
    .legend {
        position: absolute;
        bottom: 0;
    }
    .kt-portlet {
      padding: 2rem 0;
    }
</style>